module.exports = __webpack_public_path__ + "img/RithPic.24baa883.jpg";